import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useParams, useLocation, useNavigate } from 'react-router-dom';
import Header from './blocks/Header';
import Footer from './blocks/Footer';
import { Creations, ErrorPage, Home, Knowledge, Me, Notes, Tools, Travel, Loader, PostPage } from './pages/all-pages';
import './App.css';
import './i18n';
import { useTranslation } from 'react-i18next';

const validLanguages = ['en', 'de', 'ru', 'fr', 'cn', 'jp'];

const LanguageInitializer = ({ children }) => {
  const { lang = 'en' } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!validLanguages.includes(lang)) {
      navigate(`/404`, { replace: true });
    } else if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang).catch(err => {
        console.error('Failed to change language:', err);
      });
    }
  }, [lang, i18n, navigate]);

  return children;
};

const PagesRoutes = (
  <Route>
    <Route index element={<Home />} />
    <Route path="notes" element={<Notes transfile={'p-notes'} />} />
    <Route path="notes/:slug" element={<PostPage />} />
    <Route path="travel" element={<Travel transfile={'p-travel'} />} />
    <Route path="creations" element={<Creations transfile={'p-creations'} />} />
    <Route path="knowledge" element={<Knowledge transfile={'p-knowledge'} />} />
    <Route path="tools" element={<Tools transfile={'p-tools'} />} />
    <Route path="me" element={<Me transfile={'p-me'} />} />
    <Route path="404" element={<ErrorPage />} />
    <Route path="*" element={<Navigate to="404" replace />} />
  </Route>
);

const App = () => (
  <Router>
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<LanguagePathWrapper />}>
          {PagesRoutes}
          <Route path="en" element={<Navigate to="/" replace />} />
          <Route path=":lang/">
            {PagesRoutes}
          </Route>
        </Route>
      </Routes>
    </Suspense>
  </Router>
);

const HeaderWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.pathname.endsWith('/')) {
      navigate(`${location.pathname}/`, { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className='layout'>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

const LanguagePathWrapper = () => {
  return (
    <LanguageInitializer>
      <HeaderWrapper />
    </LanguageInitializer>
  );
};

export default App;
